import { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import type { RouteMeta } from 'vue-router';
import { checkAuthority } from '@/utils/common';

export default function usePermission() {
  const accessRouter = (
    route: RouteLocationNormalized | RouteRecordRaw,
    routerMode: 'show' | 'jump' | 'verifyHide' = 'show',
    toast = true
  ) => {
    const routeMatch = (route as any).matched;
    const root = routeMatch?.find((r: any) => /^\/[^\s/]+$/.test(r.path));
    if (root?.meta?.hideInMenu) return !root?.meta?.hideInMenu;
    const hasAccess =
      !route.meta?.requiresAuth ||
      !route.meta?.roles ||
      route.meta?.roles?.includes('*');
    if (hasAccess) return hasAccess;
    if (routerMode === 'show') return !!route.meta?.roles?.length;
    // routerMode === 'jump'路由跳转时校验是否有权限
    const { roles = [], permissionMode = 'every' } = route.meta as RouteMeta;
    return checkAuthority(roles, permissionMode, toast);
  };
  const findFirstPermissionRoute = (_routers: any, role = 'admin') => {
    const cloneRouters = [..._routers];
    while (cloneRouters.length) {
      const firstElement = cloneRouters.shift();
      if (
        firstElement?.meta?.roles?.find((el: string[]) => {
          return el.includes('*') || el.includes(role);
        })
      )
        return { name: firstElement.name };
      if (firstElement?.children) {
        cloneRouters.push(...firstElement.children);
      }
    }
    return null;
  };
  return {
    accessRouter,
    findFirstPermissionRoute,
  };
}
